import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import { useAuth } from "../../context/AuthProvider";

const HomePage = () => {
  const { isLoading } = useAuth();
  if (isLoading) {
    return <div>Loading...</div>;
  }
  return (
    <div className="home">
      <Navbar />
      <div className="home-container-outside">
        <div className="home-container-inside">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default HomePage;
